import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { Template } from './types/template.type';

/**
 * Updates an existing template by sending a PUT request to the API.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param data - The template data to update, including its identifier.
 * @returns A promise that resolves to the operation result of the update.
 * @throws Will throw an error if the HTTP request fails.
 */
export const updateTemplate = async (instance: KyInstance, data: Template) => {
  try {
    return await instance
      .put<OperationResult>(formatString(Uri.template.updateTemplate, data.id?.toString() ?? ''), {
        json: data,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
